import Vue from 'vue'

/**
 * 动态修改页面标题
 * @type {{inserted: pageTitle.inserted, update(*, *, *, *): void}}
 */
var pageTitle = {
    /*inserted: function (el, binding) {
        console.log(1);
        const { value } = binding
         if (value) { // 指令传参
            document.title = value + ' - 检测鉴定人员技术培训在线学习系统';
        }
    },*/
    update (el, binding, vnode, oldVnode) {
        const { value } = binding
        if (value) {
            document.title = value + ' - 检测鉴定人员技术培训在线学习系统';
        }
    }
}

Vue.directive('pageTitle', pageTitle);
